module.exports = __webpack_public_path__ + "static/fonts/Mont-ThinItalic.bb2c80c.eot";